
import { useCaseCreationStore } from "../../../../store/useCaseCreationStore";
import DeceasedDetailsForm from "../../components/forms/DeceasedDetailsForm";

export default function DeceasedDetails({ onNext, onBack }: any) {

  const { deceasedDetails, setDeceasedDetails } = useCaseCreationStore();

  return (
    <DeceasedDetailsForm
      deceasedDetails={deceasedDetails}
      setDeceasedDetails={setDeceasedDetails}
      onNext={onNext}
      onBack={onBack}
    />
  );
}
